module.exports = __webpack_public_path__ + "static/img/esdy.2043081.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/esdy.png
// module id = feKs
// module chunks = 31